import Utils from "../utils.class";

/**
 * Stat component (builder/components/stat.php): counts the title's number up from 0 when it scrolls into view,
 * easing out like the v3 home page. With "Repeat Count" it holds, then counts again, but only while on screen.
 * Skipped for reduced motion or without IntersectionObserver, so the final number simply shows.
 */
export default class Stat {

    #duration = 2200;
    #hold = 2800;

    constructor() {
        Utils.log("Registered Stat Component.");
    }

    events() {
        const counters = document.querySelectorAll('[data-hf-count]');
        const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        if (!counters.length || reduceMotion || typeof IntersectionObserver === 'undefined') {
            return;
        }

        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                const counter = entry.target.hfCounter;

                if (entry.isIntersecting) {
                    counter.start();
                } else {
                    counter.stop();
                }
            });
        }, {threshold: 0.4});

        counters.forEach((el) => {
            el.hfCounter = this.#counter(el);
            observer.observe(el);
        });
    }

    #counter(el) {
        const target = parseInt(el.getAttribute('data-hf-count'), 10) || 0;
        const commas = el.hasAttribute('data-hf-count-commas');
        const loop = el.hasAttribute('data-hf-count-loop');
        const format = (n) => commas ? n.toLocaleString('en-US') : String(n);
        let frame = null;
        let startedAt = null;
        let done = false;

        const step = (now) => {
            const elapsed = now - startedAt;

            if (loop && elapsed > this.#duration + this.#hold) {
                startedAt = now;
            } else if (elapsed >= this.#duration) {
                el.textContent = format(target);

                if (!loop) {
                    done = true;
                    frame = null;
                    return;
                }
            } else {
                const progress = elapsed / this.#duration;
                el.textContent = format(Math.round(target * (1 - Math.pow(1 - progress, 3))));
            }

            frame = requestAnimationFrame(step);
        };

        return {
            start() {
                if (frame || done) {
                    return;
                }

                // Each time it comes back on screen the count starts over from 0
                startedAt = performance.now();
                frame = requestAnimationFrame(step);
            },
            stop() {
                if (frame) {
                    cancelAnimationFrame(frame);
                    frame = null;
                    el.textContent = format(target);
                }
            },
        };
    }
}
